/* ==========================================================================
   Digitdeck — Bloque de promesa: animacion del acordeon
   --------------------------------------------------------------------------
   <details> nativo pliega de golpe: el navegador oculta el panel en cuanto se
   quita [open], asi que una transicion CSS solo puede correr al abrir. Aqui se
   toma el control del toggle para animar TAMBIEN el cierre: se mantiene [open]
   mientras la altura baja y se quita al terminar.

   Delegado en document a proposito — el cart drawer no viene en el HTML
   inicial, se sirve por Section Rendering API al abrirlo y se repinta cada vez
   que cambia el carrito. Enganchar por elemento se perderia en cada repintado.

   Sin JS el bloque sigue funcionando: es un <details> de verdad, solo que el
   plegado es instantaneo.
   ========================================================================== */

(function () {
  'use strict';

  var DURACION = 260;
  var enCurso = new WeakMap();

  function prefiereMenosMovimiento() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function panelDe(details) {
    for (var i = 0; i < details.children.length; i++) {
      if (details.children[i].classList.contains('dd-promise__panel')) {
        return details.children[i];
      }
    }
    return null;
  }

  function animar(details, abriendo) {
    var panel = panelDe(details);
    if (!panel || typeof panel.animate !== 'function') {
      // Sin WAAPI: toggle seco, sin animacion.
      if (!abriendo) details.removeAttribute('open');
      details.classList.remove('dd-promise--closing');
      return;
    }

    var previa = enCurso.get(details);
    if (previa && previa.temporizador) clearTimeout(previa.temporizador);
    if (previa && previa.anim) previa.anim.cancel();

    var alto = panel.scrollHeight;
    panel.style.overflow = 'hidden';

    var anim = panel.animate(
      [
        { height: (abriendo ? 0 : alto) + 'px', opacity: abriendo ? 0 : 1 },
        { height: (abriendo ? alto : 0) + 'px', opacity: abriendo ? 1 : 0 }
      ],
      {
        duration: DURACION,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        // Al cerrar hay que sostener el estado final: sin esto el panel vuelve
        // a su alto natural un frame antes de que se quite [open] y parpadea.
        fill: abriendo ? 'none' : 'forwards'
      }
    );

    var cerrado = false;

    function finalizar() {
      if (cerrado) return;
      cerrado = true;

      var registro = enCurso.get(details);
      if (registro && registro.temporizador) clearTimeout(registro.temporizador);
      enCurso['delete'](details);

      // Quitar [open] ANTES de cancelar: al cancelar se suelta el fill y el
      // panel recupera su alto natural, asi que primero hay que ocultarlo.
      if (!abriendo) details.removeAttribute('open');

      // Se cancela siempre, tambien al abrir. Si el timeline va congelado o
      // throttled la animacion seguiria sujetando el panel a altura 0 y el
      // bloque se veria plegado estando abierto; cancelar devuelve el alto
      // natural pase lo que pase.
      anim.cancel();

      panel.style.overflow = '';
      details.classList.remove('dd-promise--closing');
    }

    // Red de seguridad: si el timeline del documento no avanza (pestaña en
    // segundo plano, pane sin componer, animacion interrumpida), onfinish no
    // llega nunca y el bloque se quedaria trabado abierto con el chevron al
    // reves. El temporizador cierra el estado pase lo que pase.
    var temporizador = setTimeout(finalizar, DURACION + 120);

    enCurso.set(details, { anim: anim, temporizador: temporizador });

    anim.onfinish = finalizar;

    anim.oncancel = function () {
      panel.style.overflow = '';
    };
  }

  document.addEventListener('click', function (evento) {
    if (!evento.target || !evento.target.closest) return;

    var cabecera = evento.target.closest('.dd-promise__summary');
    if (!cabecera) return;

    var details = cabecera.parentElement;
    if (!details || !details.classList.contains('dd-promise--collapsible')) return;

    // Con movimiento reducido se deja el toggle nativo, que es instantaneo.
    if (prefiereMenosMovimiento()) return;

    evento.preventDefault();

    if (details.hasAttribute('open')) {
      // La clase gira el chevron de vuelta ya, sin esperar a que acabe.
      details.classList.add('dd-promise--closing');
      animar(details, false);
    } else {
      details.setAttribute('open', '');
      animar(details, true);
    }
  });

  // Marca en <html>: le dice al CSS que la animacion la lleva el JS, asi el
  // keyframe de respaldo no se solapa. Una sola vez, sirve tambien para los
  // bloques que aparezcan despues (drawer).
  document.documentElement.classList.add('dd-promise-js');
})();
